import {
  getDefaultClient,
  getWalletProviderFromWalletAccount,
} from '@dynamic-labs-sdk/client/core';

import type { AptosWalletAccount } from '../AptosWalletAccount.types';
import type { AptosClient } from '../AptosWalletProvider.types';
import { NotAptosProviderError } from '../errors/NotAptosProviderError';
import { isAptosWalletProvider } from '../isAptosWalletProvider';

type GetAptosClientParams = {
  walletAccount: AptosWalletAccount;
};

/**
 * Retrieves an Aptos client from a wallet account.
 *
 * @param params.walletAccount - The wallet account to get the Aptos client for.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 *
 * @returns A promise that resolves to an AptosClient instance
 * @throws NotAptosProviderError If the wallet account's provider is not an APTOS provider
 */
export const getAptosClient = async (
  { walletAccount }: GetAptosClientParams,
  client = getDefaultClient()
): Promise<AptosClient> => {
  const provider = getWalletProviderFromWalletAccount(
    {
      walletAccount,
    },
    client
  );

  if (!isAptosWalletProvider(provider)) {
    throw new NotAptosProviderError({ providerKey: provider.key });
  }

  return provider.getAptosClient({ walletAccount });
};
